export default __webpack_public_path__ + "static/media/ad-3.68face69.png";